
import { motion } from "framer-motion";
import { Users, Target, GraduationCap, Award } from "lucide-react";

interface Feature {
  icon: JSX.Element;
  title: string;
  description: string;
}

interface DifferenceSectionProps {}

const DifferenceSection = ({}: DifferenceSectionProps) => {
  const features: Feature[] = [
    {
      icon: <Target className="w-10 h-10 text-corporate-primary-75" />,
      title: "Fully Automated Gateway",
      description: "Our METRADE app and gateway connect you to proven trading strategies without requiring in-depth market knowledge."
    },
    {
      icon: <Award className="w-10 h-10 text-corporate-primary-75" />,
      title: "Expert Verification",
      description: "We collaborate exclusively with verified service providers to ensure transparent, trustworthy performance."
    },
    {
      icon: <Users className="w-10 h-10 text-corporate-primary-75" />,
      title: "Emotional Resilience",
      description: "Through automation, our users avoid the pitfalls of emotional trading in a volatile market—allowing them to focus on long-term growth."
    },
    {
      icon: <GraduationCap className="w-10 h-10 text-corporate-primary-75" />,
      title: "Constant Innovation",
      description: "We continuously refine our platform to adapt to market shifts, user feedback, and emerging technologies."
    }
  ];

  return (
    <section className="px-4 py-16 bg-gradient-to-b from-white to-corporate-primary-25">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-3 text-corporate-primary-100">What Makes Us Different</h2>
        <div className="w-24 h-1 bg-corporate-secondary-100 mx-auto mb-12"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-corporate-secondary-100 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="mb-6 transform group-hover:scale-110 transition-transform duration-300">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-4 text-corporate-primary-100">{feature.title}</h3>
              <p className="text-corporate-neutral-75 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferenceSection;
